import React from "react"

function ShimmerLine({ className = "" }) {
    return <div className={"pp-dematching-stats-skeleton__line " + className} />
}

export function DematchingKpiSkeleton() {
    return (
        <div className="pp-matching-stats-kpi pp-dematching-stats-skeleton-kpi" aria-hidden="true">
            <div className="pp-dematching-stats-skeleton__accent" />
            <div className="pp-matching-stats-kpi__body">
                <ShimmerLine className="pp-dematching-stats-skeleton__line--label" />
                <ShimmerLine className="pp-dematching-stats-skeleton__line--value" />
                <ShimmerLine className="pp-dematching-stats-skeleton__line--sub" />
            </div>
        </div>
    )
}

export function DematchingPanelSkeleton({ height = 140 }) {
    return (
        <div className="pp-matching-stats-panel pp-dematching-stats-skeleton-panel" aria-hidden="true">
            <ShimmerLine className="pp-dematching-stats-skeleton__line--title" />
            <div className="pp-dematching-stats-skeleton__block" style={{ height }} />
        </div>
    )
}

export function DematchingListSkeleton({ rows = 4 }) {
    return (
        <div className="pp-matching-stats-panel pp-dematching-stats-skeleton-panel" aria-hidden="true">
            <ShimmerLine className="pp-dematching-stats-skeleton__line--title" />
            <div className="pp-dematching-stats-skeleton-list">
                {Array.from({ length: rows }, (_, i) => (
                    <div key={i} className="pp-dematching-stats-skeleton-list__row">
                        <ShimmerLine className="pp-dematching-stats-skeleton__line--list-name" />
                        <ShimmerLine className="pp-dematching-stats-skeleton__line--list-value" />
                    </div>
                ))}
            </div>
        </div>
    )
}

export function DematchingStatsPopIn({ children }) {
    return <div className="pp-dematching-stats-pop-in">{children}</div>
}
